<template>
  <div class="container">
    <wrap-container class="w100">
      <footer>
        <p>
          Términos y condiciones de tratamiento de datos
          <br />
          Dirección: Av. Córdoba 111 Piso 31, CABA
          <br />
          Teléfono: 0800-333-0303
          <br />
          CUIT: 30-50000319-3
          <br />
          <br />
        </p>
        <p>
          <b>Términos y condiciones de tratamiento de datos</b>
          <br />
          Los datos personales aquí incluidos tienen el carácter de declaración
          jurada y son recogidos para ser incorporados y tratados en una base de
          datos, la cual se encuentra registrada en la Agencia de Acceso a la
          Información Pública, cuyo destinatario y titular es el Banco BBVA
          Argentina S.A. Cualquier falseamiento, error y/o inexactitud respecto
          a la información implicará la supresión de estos datos de la base de
          referencia y no podrán ser utilizados a futuro.
          <br />
          <br />
          El usuario presta su consentimiento expreso al BBVA, para que toda la
          información referente a su persona, sus actividades económicas o las
          operaciones que haya concertado o que concierte en el futuro (en
          adelante y en su conjunto "la información") pueda ser transferida y
          cedida, aun en forma gratuita, dentro de estrictas políticas de
          confidencialidad y seguridad de los datos, a sus afiliadas,
          subsidiarias, controlantes, controladas y otras entidades de Grupo
          BBVA y/o cualquier tercero. La información podrá ser utilizada para:
          a) La realización de segmentaciones o perfiles del Cliente, con fines
          comerciales a efectos de adaptar los productos o servicios a
          necesidades o características específicas, así como con fines de
          análisis de riesgos para evaluar nuevas operaciones, en ambos
          supuestos conservando dichas segmentaciones o perfiles en tanto y en
          cuanto el interviniente mantenga relación contractual con el BBVA,
          pudiendo oponerse en cualquier momento a dicho tratamiento; b) El
          envío a través de cualquier medio, por parte del BBVA de otros
          terceros, de ofertas comerciales, distintos tipos de informaciones o
          publicidades, personalizadas o no, sobre productos o servicios propios
          o de terceros; c) Para cualquier otra finalidad no incompatible con
          las especificadas anteriormente. Cuando así lo disponga, el usuario
          tendrá el derecho de acceder a la información y solicitar su
          rectificación o supresión de la base de archivo.
          <br />
          <br />
          El BBVA informa al usuario que sus datos personales podrán ser cedidos
          a las autoridades competentes cuando las leyes o regulaciones de
          aplicación así lo establezcan.
          <br />
          <br />
          En función del Estándar de la Organización para la Cooperación y
          Desarrollo Económicos (OCDE) para el Intercambio Automático de
          Información en Asuntos Fiscales y de las disposiciones de la Ley de
          cumplimiento fiscal de cuentas extranjeras (“Foreign Account Tax
          Compliance Act” - FATCA) de los Estados Unidos de América, el cliente
          autoriza al Banco a ceder información a autoridades de terceros países
          por operatorias desarrolladas en los mercados internacionales tales
          como Estados Unidos. Lo expuesto, ya sea de forma agregada o
          individual, según el caso. El titular de los datos personales tiene el
          derecho de acceso a los mismos en forma gratuita en intervalos no
          inferiores a seis meses, salvo que se acredite un interés legítimo al
          efecto conforme lo establecido en el artículo 14, inciso 3 de la Ley
          25.326.
          <br />
          <br />
          La AGENCIA DE ACCESO A LA INFORMACIÓN PUBLICA, Órgano de Control de la
          Ley Nº 25.326, tiene la atribución de atender las denuncias y reclamos
          que se interpongan con relación al incumplimiento de las normas sobre
          protección de datos personales.
          <br />
          <br />
          <b>Sistemas de Biometría:</b>
          <br />
          En caso de que el BBVA defina el uso de dispositivos para la captura,
          lectura y/o procesamiento de datos –inclusive aquellos de carácter
          biométricos– en alguno de sus procesos operativos y/o de seguridad
          aplicables, el usuario autoriza al BBVA a compartir estos datos con
          terceros exclusivamente para el resguardo de la información capturada,
          la verificación de la identidad del titular de los datos y/o con los
          fines que el BBVA determine.
          <br />
          <br />
          <b>Sistemas de información crediticia:</b>
          <br />
          Ante la solicitud de cualquier producto, el BBVA puede solicitar
          información a las agencias de informes comerciales a fin de evaluar la
          situación crediticia del usuario.
          <br />
          <br />
          El usuario acepta que estará sujeto a la clasificación e inclusión en
          la "Central de deudores del sistema financiero", de conformidad a la
          normativa vigente del B.C.R.A., dado que es obligación del BBVA
          informar, solamente, al Banco Central de la República Argentina todos
          los datos que éste le requiera o que pudiera requerirle en el futuro,
          relacionados con sus Clientes. No será responsabilidad del BBVA la
          utilización de la información del usuario por parte de terceros
          distintos al B.C.R.A., dado que la misma no es proporcionada por el
          Banco.
        </p>
      </footer>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";

export default {
  name: "AppFooter",
  components: { WrapContainer }
};
</script>

<style scoped>
.container {
  background: #011f3f;
  color: #e4e4e4;
  font-size: 12px;
  line-height: 1.5em;
  padding: 17px;
  margin-left: -17px;
  margin-right: -17px;
  text-align: justify;
  margin-bottom: 0px;
}

@media screen and (max-width: 600px) {
  p {
    font-size: 16px;
    line-height: 26px;
  }
}
</style>
